import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { createAction, props, Store } from '@ngrx/store';
import { UpsertManySuccess, UpsertSuccess } from '@briebug/ngrx-auto-entity';
import { map, switchMap } from 'rxjs/operators';
import { AppState } from './app.state';
import { Bid, BidItem, BidWorksheet } from '@app/models';
import { BidService } from '@services/api/bid.service';

export const loadBidDetail = createAction(
  '[Bids] Load Detail',
  props<{ id: string }>()
);

@Injectable()
export class BidEffects {
  // The retrieve response nests items and worksheets; store them separately.
  loadDetail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadBidDetail),
        switchMap(action =>
          this.bids.getBid(action.id).pipe(
            map(detail => {
              const { items, worksheets, ...bid } = detail;
              this.store$.dispatch(new UpsertSuccess(Bid, bid));
              this.store$.dispatch(new UpsertManySuccess(BidItem, items));
              this.store$.dispatch(
                new UpsertManySuccess(BidWorksheet, worksheets)
              );
            })
          )
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private bids: BidService,
    private store$: Store<AppState>
  ) {}
}
